import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { SparkMenu } from '../ui/spark';
import LeftMainmenuItem from '../helpers/LeftMainmenuItem';
import AppMenuConfig from '../../config/Menu';
import { MENU_ITEMS_ASSETS } from '../../constants/MenuItems';
import { checkPermissions } from '../../../lib/utils';
import { ACCESS_POINTS_GROUP } from '../../constants/AccessPoints';

class NavigationAssets extends Component {
    hasAccessToMenuElement(sectionName) {
        switch (sectionName) {
            case MENU_ITEMS_ASSETS.IMAGES:
            case MENU_ITEMS_ASSETS.CUSTOMFONTS:
            case MENU_ITEMS_ASSETS.OTHER:
                return (
                    this.props.hasAccessThemes.view ||
                    this.props.hasAccessThemes.edit ||
                    this.props.hasAccessCustomContent.view ||
                    this.props.hasAccessCustomContent.edit
                );
            case MENU_ITEMS_ASSETS.CUSTOMIZATION:
                return this.props.hasAccessCustomContent.view || this.props.hasAccessCustomContent.edit;
            case MENU_ITEMS_ASSETS.TRACKING:
                return this.props.hasAccessTrackingHooks.view || this.props.hasAccessTrackingHooks.edit;
            default:
                return false;
        }
    }

    componentDidMount() {
        this.menuInstance = new SparkMenu(this.node);
    }

    render() {
        const menuItemsGlobal = AppMenuConfig.assets.menuItems;

        return (
            <div className="NavigationAssets">
                <div className="container">
                    <Link to="/">
                        <div className="row">
                            <div className="col-md-2">
                                <i style={{ marginTop: 6 }} className="spark-icon-arrow-basic-left spark-icon--xd" />
                            </div>
                            <div className="col-md-10 link-to-home">Home</div>
                        </div>
                    </Link>
                </div>
                <LeftMainmenuItem icon="spark-icon-design-palette" title="Assets" copy="" />
                <div className="spark-panel__content leftnav-menu-submenu-container">
                    <nav
                        ref={node => (this.node = node)}
                        className="spark-menu spark-menu--panel col-xs-12 col-col-md-12 col-lg-12 col-xl-12"
                    >
                        <ul className="spark-menu__list">
                            {menuItemsGlobal.map((elm, i) => {
                                if (this.hasAccessToMenuElement(elm.link)) {
                                    // workaround as the Spark FW sets a className "active" on the <li> elm
                                    const active = `/assets/${elm.link}` === this.props.location.pathname;
                                    const cssClassName = active
                                        ? 'spark-menu__list-item active'
                                        : 'spark-menu__list-item';
                                    return (
                                        <li key={`item${i}`} className={cssClassName}>
                                            <Link
                                                to={`/assets/${elm.link}`}
                                                activeClassName="active"
                                                className="spark-menu__list-link"
                                            >
                                                {elm.name}
                                            </Link>
                                        </li>
                                    );
                                } else {
                                    return (
                                        <li key={`item${i}`} className={'spark-menu__list-item disabled-link'}>
                                            <Link disabled={true} className="spark-menu__list-link">
                                                {elm.name}
                                            </Link>
                                        </li>
                                    );
                                }
                            })}
                        </ul>
                    </nav>
                </div>
            </div>
        );
    }
}

NavigationAssets.propTypes = {
    location: PropTypes.object
};

const mapStateToProps = state => {
    return {
        hasAccessThemes: checkPermissions(state, ACCESS_POINTS_GROUP.THEMES),
        hasAccessCustomContent: checkPermissions(state, ACCESS_POINTS_GROUP.CUSTOM_CONTENT),
        hasAccessTrackingHooks: checkPermissions(state, ACCESS_POINTS_GROUP.TRACKING_HOOKS)
    };
};

export default connect(mapStateToProps)(NavigationAssets);



// WEBPACK FOOTER //
// ./src/components/assets/NavigationAssets.js